"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseTool_1 = require("./BaseTool");
const arcgis_1 = require("@terraformer/arcgis");
const geometry_engine_1 = __importDefault(require("./esri/geometry-engine"));
const geojson_1 = require("../../geojson");
const features_1 = require("../../features");
class VertexEditTool extends BaseTool_1.BaseTool {
    constructor() {
        super(...arguments);
        this.getFilteredFeatureCollection = (featureCollection, editedFeature) => {
            const features = featureCollection.features.filter((feature) => {
                return feature.id !== editedFeature.id;
            });
            return geojson_1.GeoJsonUtils.featuresToFeatureCollection(features);
        };
        this.onComplete = (currentFeatures, newFeatures, boundary) => __awaiter(this, void 0, void 0, function* () {
            const editedFeature = newFeatures.features[0];
            // get features other than the edited one
            const esriPolygons = (0, arcgis_1.geojsonToArcGIS)(this.getGeometryCollection(this.getFilteredFeatureCollection(currentFeatures, editedFeature)));
            // Throw an error if the feature currently being edited is in the features to process
            if (esriPolygons.length === currentFeatures.features.length) {
                throw Error("Could not find current edited feature");
            }
            const updated = [];
            let editedEsriPolygon = (0, arcgis_1.geojsonToArcGIS)(editedFeature.geometry);
            const ge = yield geometry_engine_1.default.instance();
            if (boundary) {
                //find the boundary
                const boundaryPolygon = (0, arcgis_1.geojsonToArcGIS)(boundary.geometry);
                //Get source polygon intersecting with the boundary
                editedEsriPolygon = ge.intersect(boundaryPolygon, editedEsriPolygon);
            }
            if (editedEsriPolygon) {
                for (const poly of esriPolygons) {
                    try {
                        const intersecting = ge.intersects(poly, editedEsriPolygon);
                        // check intersection with each polygon
                        if (intersecting) {
                            const intersected = ge.intersect(poly, editedEsriPolygon);
                            // remove intersected from the existing
                            const diff = ge.difference(poly, intersected);
                            diff && updated.push(diff);
                        }
                        else {
                            updated.push(poly);
                        }
                    }
                    catch (e) {
                        alert(`The last vertex edit is invalid`);
                    }
                }
                const geometries = updated
                    .map((poly) => (0, arcgis_1.arcgisToGeoJSON)(poly))
                    .filter((geometry) => geometry.type === "MultiPolygon" || geometry.type === "Polygon");
                const featureCollection = this.getFeatureCollection(geometries);
                // Add edited polygon to the feature
                // Type coercion is safe because only polygons came in.
                const intersectedGeometry = (0, arcgis_1.arcgisToGeoJSON)(editedEsriPolygon);
                const intersectedFeature = Object.assign(Object.assign({}, editedFeature), { geometry: intersectedGeometry });
                featureCollection.features.push(intersectedFeature);
                features_1.featureIdGenerator.updateFeatureIds(featureCollection);
                return featureCollection;
            }
            return currentFeatures;
        });
    }
}
exports.default = new VertexEditTool();
